function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Checkmark");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Alert",
  transform: "translate(-19.000000, -31.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Icons/Checkmark"
}, React.createElement("g", {
  transform: "translate(16.000000, 27.000000)"
}, React.createElement("path", {
  d: "M13.1093088,4.00037393 C12.8844799,4.00718592 12.6710257,4.10469182 12.5141359,4.27224893 L7.28833077,9.70507493 L4.42971199,7.35194243 C4.18868702,7.13686631 3.85372909,7.07626808 3.55698667,7.19405508 C3.26024425,7.31184209 3.04936749,7.5891004 3.00755204,7.91644536 C2.96573659,8.24379031 3.09969707,8.56865767 3.35658304,8.76287993 L6.81940671,11.6128949 C7.16426026,11.8963061 7.65866946,11.8660681 7.96917965,11.5425749 L13.7405527,5.54256143 C13.9948103,5.28319993 14.0703197,4.88841139 13.9308433,4.54765757 C13.7913669,4.20690376 13.4653731,3.98973573 13.1093088,4.00037393 L13.1093088,4.00037393 Z",
  id: "Path"
})))));

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "8px",
    viewBox: "0 0 11 8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.eee1b7b8.svg";
export { ForwardRef as ReactComponent };